import { connect } from 'react-redux';
import Waitlist from './Waitlist';

export default connect(({ settings, product, order }) => ({
  ...settings,
  product: product.data,
  variantSelected: order.variantSelected,
  selectedLocation: order.selectedLocation,
}))(Waitlist);
